import { useMutation } from "@tanstack/react-query";
import { useAppSelector } from "redux/hooks";
import { AD_TYPES } from "./constants";
import api from "utils/api";

const AUDIENCE_QUERY_AD_TYPE_MAP = {
  [AD_TYPES.SPONSORED_DISPLAY_V2.value]: "SPONSORED_DISPLAY",
  [AD_TYPES.SPONSORED_DISPLAY.value]: "SPONSORED_DISPLAY",
  [AD_TYPES.SPONSORED_PRODUCT.value]: "SPONSORED_PRODUCTS",
  [AD_TYPES.SPONSORED_PRODUCT_AUTO.value]: "SPONSORED_PRODUCTS",
  [AD_TYPES.SPONSORED_BRAND_V2.value]: "SPONSORED_BRANDS",
  [AD_TYPES.SPONSORED_BRAND.value]: "SPONSORED_BRANDS",
  [AD_TYPES.SPONSORED_BRAND_VIDEO.value]: "SPONSORED_BRANDS",
};

export const useTargetableEntities = (searchQueryFilter, adType, onSuccess = () => {}) => {
  const { marketPlace } = useAppSelector((state) => state.marketPlace);

  const fetchTargetableEntities = async () => {
    const body = {
      marketplace: marketPlace,
      search_query_filter: searchQueryFilter,
      ad_product: AUDIENCE_QUERY_AD_TYPE_MAP[adType],
    };
    return await api.post("/targetable_entities/", body);
  };

  const mutation = useMutation({
    mutationFn: fetchTargetableEntities,

    onSuccess: (res) => {
      const data = res ?? [];
      onSuccess(data);
    },
  });

  return mutation;
};
